import Status from "shared/components/Status";
import { ASSET_TYPES } from "utils/constants";
import { formatters } from "utils/helpers";

const Card = ({
  icon,
  status = "active",
  amount,
  asset,
  onClick,
  className = "",
  ...rest
}) => {
  const isActive = status === "active";

  const cardClasses = [
    "account__card",
    isActive ? "account__card--active" : "account__card--inactive",
    onClick && "account__card--clickable",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const { icon: flag, mirror } = Object.values(ASSET_TYPES).find(
    (value) => value.type === asset.type
  );

  return (
    <div className={cardClasses} onClick={onClick} {...rest}>
      <div className="account__card--amount">
        <div className="--baseline">
          <span className="--value">{formatters.amounts(amount)}</span>
          <span className="--currency">{mirror}</span>
        </div>
      </div>
      <div className="account__card--header">
        <div className="account__card--flag">
          <span className="--icon">{flag}</span>
          <span className="--pair">{mirror}</span>
        </div>
        <div className="account__card--status">
          <Status name={status} variant="arrow" size="medium" />
        </div>
      </div>
    </div>
  );
};

export default Card;
